import type { ChatHistory, ChatSession, FeedbackOption, PromptRequest } from './Types';
import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class CoblinatorRequester {
  private requester: Requester;

  private readonly baseUrl: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.baseUrl = '/coblinator/v1';
  }

  public requestResponse = async (request: PromptRequest): Promise<ChatHistory> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/prompt`,
      method: HttpMethod.POST,
      body: JSON.stringify(snakecaseKeys({ ...request }, { deep: true })),
    };

    const { data } = await this.requester.request(requestData);
    return camelcaseKeys(data, { deep: true }).data;
  };

  public getChatHistory = async (): Promise<ChatSession[]> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/chat-history`,
      method: HttpMethod.GET,
    };

    const response = await this.requester.request(requestData);
    return camelcaseKeys(response.data.data, {
      deep: true,
    });
  };

  public giveFeedback = async (chatHistoryId: number, feedback: FeedbackOption): Promise<ChatHistory> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/chat-history/${chatHistoryId}/feedback`,
      method: HttpMethod.PATCH,
      body: JSON.stringify({
        feedback,
      }),
    };

    const { data } = await this.requester.request(requestData);
    return camelcaseKeys(data, { deep: true }).data;
  };
}

export default CoblinatorRequester;
